module.exports = __webpack_public_path__ + "static/media/ios-infinite.fe08e3ab.svg";